import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Spin, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";

const ProfileAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { myUsersData } = useSelector((state) => state.fetch);
  const { activeObj } = useSelector((state) => state.obj);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (data) => {
    data.profId = activeObj?.profId ? activeObj?.profId : null;
    const res = await dispatch(
      save({
        ...data,
        url: "prof/profile",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch()
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObj,
    });
  }, [activeObj, form]);

  const initialFormValues = {
    ...activeObj,
  };

  return (
    <Modal
      title={"Add a new Profile"}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[39.75rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
        initialValues={initialFormValues}
      >
        <Form.Item
          name="profProfile"
          label={"Profile Name"}
          rules={[
            {
              required: true,
              message: "Please add profile name",
            },
          ]}
        >
          <Input placeholder="eg system admin" className="input" />
        </Form.Item>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? (
                  <Spin />
                ) : prodd?.profId ? (
                  "Update Profile"
                ) : (
                  "Save Profile"
                )}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default ProfileAdd;
